import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaUser, FaFutbol, FaGraduationCap, FaUserFriends, FaCheck } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationError, setVerificationError] = useState('');
  const navigate = useNavigate();
  
  const ghanaRegionsAndDistricts = {
    "Ahafo": ["Asunafo North", "Asunafo South", "Asutifi North", "Asutifi South", "Tano North", "Tano South"],
    "Ashanti": ["Adansi North", "Adansi South", "Afigya Kwabre", "Ahafo Ano North", "Ahafo Ano South", "Amansie Central", "Amansie West", "Asante Akim Central", "Asante Akim North", "Asante Akim South", "Atwima Kwanwoma", "Atwima Mponua", "Atwima Nwabiagya", "Bekwai", "Bosome Freho", "Bosomtwe", "Ejisu", "Ejura Sekyedumase", "Juaben", "Kumasi Metropolitan", "Kwabre East", "Mampong", "Obuasi", "Offinso", "Offinso North", "Sekyere Afram Plains", "Sekyere Central", "Sekyere East", "Sekyere Kumawu", "Sekyere South"],
    "Bono": ["Banda", "Berekum East", "Berekum West", "Dormaa Central", "Dormaa East", "Dormaa West", "Jaman North", "Jaman South", "Sunyani", "Sunyani West", "Tain", "Wenchi"],
    "Bono East": ["Atebubu-Amantin", "Kintampo North", "Kintampo South", "Nkoranza North", "Nkoranza South", "Pru East", "Pru West", "Sene East", "Sene West", "Techiman", "Techiman North"],
    "Central": ["Abura-Asebu-Kwamankese", "Agona East", "Agona West", "Ajumako-Enyan-Essiam", "Asikuma-Odoben-Brakwa", "Assin Central", "Assin North", "Assin South", "Awutu Senya East", "Awutu Senya West", "Cape Coast Metropolitan", "Effutu", "Ekumfi", "Gomoa Central", "Gomoa East", "Gomoa West", "Komenda-Edina-Eguafo-Abirem", "Mfantsiman", "Twifo-Ati Morkwa", "Twifo-Heman-Lower Denkyira", "Upper Denkyira East", "Upper Denkyira West"],
    "Eastern": ["Akuapim North", "Akuapim South", "Akyemansa", "Asuogyaman", "Atiwa East", "Atiwa West", "Ayensuano", "Birim Central", "Birim North", "Birim South", "Denkyembour", "Fanteakwa North", "Fanteakwa South", "Kwaebibirem", "Kwahu Afram Plains North", "Kwahu Afram Plains South", "Kwahu East", "Kwahu South", "Kwahu West", "Lower Manya Krobo", "New Juaben North", "New Juaben South", "Nsawam Adoagyiri", "Suhum", "Upper Manya Krobo", "Upper West Akim", "West Akim", "Yilo Krobo"],
    "Greater Accra": ["Ablekuma Central", "Ablekuma North", "Ablekuma West", "Ada East", "Ada West", "Adenta", "Ashaiman", "Ayawaso Central", "Ayawaso East", "Ayawaso North", "Ayawaso West", "Ga Central", "Ga East", "Ga North", "Ga South", "Ga West", "Korle Klottey", "Kpone Katamanso", "Krowor", "La Dadekotopon", "La Nkwantanang Madina", "Ledzokuku", "Ningo-Prampram", "Okaikwei North", "Sege", "Shai Osudoku", "Tema Metropolitan", "Tema West", "Weija Gbawe"],
    "North East": ["Bunkpurugu-Nakpanduri", "Chereponi", "East Mamprusi", "Mamprugu Moagduri", "West Mamprusi", "Yunyoo-Nasuan"],
    "Northern": ["Gushegu", "Karaga", "Kpandai", "Kumbungu", "Mion", "Nanton", "Nanumba North", "Nanumba South", "Saboba", "Sagnarigu", "Savelugu", "Tamale Metropolitan", "Tatale-Sanguli", "Tolon", "Yendi", "Zabzugu"],
    "Oti": ["Biakoye", "Jasikan", "Kadjebi", "Krachi East", "Krachi Nchumuru", "Krachi West", "Nkwanta North", "Nkwanta South"],
    "Savannah": ["Bole", "Central Gonja", "East Gonja", "North Gonja", "North East Gonja", "Sawla-Tuna-Kalba", "West Gonja"],
    "Upper East": ["Bawku Municipal", "Bawku West", "Binduri", "Bolgatanga East", "Bolgatanga Municipal", "Bongo", "Builsa North", "Builsa South", "Garu", "Kassena Nankana East", "Kassena Nankana West", "Nabdam", "Pusiga", "Talensi", "Tempane"],
    "Upper West": ["Daffiama-Bussie-Issa", "Jirapa", "Lambussie Karni", "Lawra", "Nadowli-Kaleo", "Nandom", "Sissala East", "Sissala West", "Wa East", "Wa Municipal", "Wa West"],
    "Volta": ["Adaklu", "Afadjato South", "Agotime Ziope", "Akatsi North", "Akatsi South", "Anloga", "Central Tongu", "Ho", "Ho West", "Hohoe", "Keta", "Ketu North", "Ketu South", "Kpando", "North Dayi", "North Tongu", "South Dayi", "South Tongu"],
    "Western": ["Ahanta West", "Amenfi Central", "Amenfi East", "Amenfi West", "Effia", "Ellembelle", "Jomoro", "Kwesimintsim", "Mpohor", "Nzema East", "Prestea-Huni Valley", "Sekondi-Takoradi Metropolitan", "Shama", "Tarkwa-Nsuaem", "Wassa Amenfi Central", "Wassa East"],
    "Western North": ["Aowin", "Bia East", "Bia West", "Bibiani-Anhwiaso-Bekwai", "Bodi", "Juaboso", "Sefwi Akontombra", "Sefwi Wiawso", "Suaman"]
  };
  
  const [formData, setFormData] = useState({
    // Personal Information
    first_name: '',
    last_name: '',
    date_of_birth: '',
    nationality: '',
    gender: '',
    personal_contact: '',
    email: '',
    region: '',
    district: '',
    town: '',
    // Player Details
    position: '',
    preferred_foot: '',
    height: '',
    has_current_club: '',
    current_club: '',
    has_club_card: '',
    // Academic Information
    current_school: '',
    grade: '',
    // Guardian Information
    guardian_name: '',
    relationship: '',
    phone: '',
    address: '',
  });

  const steps = [
    { number: 1, title: "Personal Info", icon: <FaUser /> },
    { number: 2, title: "Player Details", icon: <FaFutbol /> },
    { number: 3, title: "Academic Info", icon: <FaGraduationCap /> },
    { number: 4, title: "Guardian Info", icon: <FaUserFriends /> },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRegionChange = (e) => {
    const selectedRegion = e.target.value;
    setFormData(prev => ({
      ...prev,
      region: selectedRegion,
      district: '' // Reset district when region changes
    }));
  };

  const nextStep = () => {
    // Validate current step before proceeding
    if (step === 1) {
      // Personal Information validation
      if (!formData.first_name || !formData.last_name || !formData.date_of_birth || 
          !formData.nationality || !formData.gender || !formData.personal_contact || !formData.email) {
        toast.error('Please fill in all required fields in Personal Information', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
    } else if (step === 2) {
      // Player Details validation
      if (!formData.position || !formData.preferred_foot || !formData.height || 
          !formData.has_current_club || !formData.has_club_card) {
        toast.error('Please fill in all required fields in Player Details', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      // If has_current_club is "yes", validate current_club
      if (formData.has_current_club === "yes" && !formData.current_club) {
        toast.error('Please enter your current club name', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
    } else if (step === 4) {
      // Guardian Information validation
      if (!formData.guardian_name || !formData.relationship || !formData.phone || !formData.address) {
        toast.error('Please fill in all required fields in Guardian Information', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
    }
    
    // If validation passes, proceed to next step
    setStep(prev => Math.min(prev + 1, steps.length));
  };

  const prevStep = () => {
    setStep(prev => Math.max(prev - 1, 1));
  };

  const verifyRegistration = async () => {
    setShowVerificationModal(true);
    setVerificationError('');
    
    try {
      const response = await axios.get(' https://ksa-manager-back.onrender.com/fetch_registered_players');
      
      if (response.data && response.data.success === true) {
        // If verification is successful, proceed with payment
        setShowVerificationModal(false);
        initializePayment();
      } else {
        setVerificationError('Verification failed. Please try again.');
      }
    } catch (error) {
      console.error('Verification error:', error);
      setVerificationError('Failed to verify. Please try again.');
    }
  };

  const handleSubmit = async () => {
    // Validate all required fields before submission
    if (!formData.first_name || !formData.last_name || !formData.date_of_birth || 
        !formData.nationality || !formData.gender || !formData.personal_contact || !formData.email ||
        !formData.position || !formData.preferred_foot || !formData.height || 
        !formData.has_current_club || !formData.has_club_card ||
        !formData.guardian_name || !formData.relationship || !formData.phone || !formData.address) {
      toast.error('Please fill in all required fields before submitting', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    
    // If has_current_club is "yes", validate current_club
    if (formData.has_current_club === "yes" && !formData.current_club) {
      toast.error('Please enter your current club name', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    
    // Start verification process
    verifyRegistration();
  };

  // Initialize Paystack payment
  const initializePayment = () => {
    setPaymentProcessing(true);
    
    // Create a unique reference for this transaction
    const reference = `KSA_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    
    // Configure Paystack payment
    const handler = window.PaystackPop.setup({
      key: 'pk_live_600b57c273f7236a391db5487282251ec1ff47c0', // Live Paystack public key
      email: formData.email, // Use the email from form data
      amount: 10000, // Amount in kobo (100 GHS = 10000 kobo)
      currency: 'GHS',
      ref: reference,
      callback: function(response) {
        // Payment successful, proceed with registration
        processRegistration(reference, response.reference);
      },
      onClose: function() {
        // Payment window closed
        setPaymentProcessing(false);
      }
    });
    
    handler.openIframe();
  };

  // Process registration after successful payment
  const processRegistration = async (reference, paymentReference) => {
    setIsSubmitting(true);
    setSubmitError('');
    setShowLoader(true); // Show the loader modal
    
    try {
      // Add payment reference to the form data
      const dataToSubmit = {
        // Personal Information
        first_name: formData.first_name,
        last_name: formData.last_name,
        date_of_birth: formData.date_of_birth,
        nationality: formData.nationality,
        gender: formData.gender,
        personal_contact: formData.personal_contact,
        email: formData.email,
        region: formData.region,
        district: formData.district,
        town: formData.town,
        
        // Player Details
        position: formData.position,
        preferred_foot: formData.preferred_foot,
        height: formData.height,
        has_current_club: formData.has_current_club,
        current_club: formData.current_club || '', // Ensure this is always a string
        has_club_card: formData.has_club_card,
        
        // Academic Information
        current_school: formData.current_school || '', // Ensure this is always a string
        grade: formData.grade || '', // Ensure this is always a string
        
        // Guardian Information
        guardian_name: formData.guardian_name,
        relationship: formData.relationship,
        phone: formData.phone,
        address: formData.address,
        
        // Payment Information
        payment_reference: paymentReference,
        registration_reference: reference
      };

      // Log the data being sent
      console.log('Submitting data:', dataToSubmit);
      
      const response = await axios.post(' https://ksa-manager-back.onrender.com/register_player', dataToSubmit);
      
      if (response.data && response.data.message) {
        toast.success('Registration successful! Redirecting...', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        
        // Redirect to success page after a delay
        setTimeout(() => {
          navigate('/auth/success');
        }, 3000);
      }
    } catch (error) {
      console.error('Registration error:', error);
      // Log the error response data if available
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
        console.error('Error response headers:', error.response.headers);
      }
      setSubmitError(error.response?.data?.message || 'Failed to register. Please try again.');
    } finally {
      setIsSubmitting(false);
      setPaymentProcessing(false);
      setShowLoader(false); // Hide the loader modal
    }
  };

  // Load Paystack script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen relative">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-blue-900">
          <div className="absolute inset-0 opacity-5" 
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M30 0L0 30h60L30 0zm0 60L60 30H0l30 30z" fill="%23ffffff" fill-opacity="0.4"/%3E%3C/svg%3E")',
                        backgroundSize: '30px 30px' }}>
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Hero Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12 mb-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Trial Registration
                </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Register for a trial at our academy and take the first step towards your professional football career.
                </p>
                <div className="bg-yellow-600/20 border border-yellow-500/30 rounded-lg p-4 mb-6">
                  <p className="text-yellow-200 font-medium">
                    <span className="font-bold">Registration Fee:</span> 100.00 Cedis required for registration form and trial at academy premises.
                  </p>
                </div>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Professional Training</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Expert Coaches</span>
                  </div>
                  <div className="flex items-center gap-2 text-blue-100">
                    <FaCheck className="text-green-400" />
                    <span>Career Development</span>
                  </div>
                </div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                  <motion.img
                    src="https://images.pexels.com/photos/3621104/pexels-photo-3621104.jpeg"
                    alt="Player Registration"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.3 }}
                  />
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg"
                  >
                    <p className="text-sm font-semibold">Join Our Academy</p>
                    <p className="text-xs opacity-80">Limited Spots Available</p>
                  </motion.div>
                </div>
              </motion.div>
            </div>

            {/* Registration Form Section */}
            <section className="py-12 bg-white/5">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto w-full">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-12"
                  >
                    <h2 className="text-3xl font-bold text-white mb-4">Trial Registration Form</h2>
                    <p className="text-xl text-blue-100">Please fill out all required information</p>
                  </motion.div>

                  {/* Progress Steps */}
                  <div className="mb-12">
                    <div className="flex justify-between items-center">
                      {steps.map((s, i) => (
                        <div key={s.number} className="flex-1 relative">
                          <div className="flex flex-col items-center">
                            <motion.div
                              initial={{ scale: 0.8 }}
                              animate={{ 
                                scale: step >= s.number ? 1 : 0.8,
                                backgroundColor: step >= s.number ? 'rgb(37, 99, 235)' : 'rgba(255, 255, 255, 0.1)'
                              }}
                              className={`w-12 h-12 rounded-full flex items-center justify-center text-white mb-2
                                ${step >= s.number ? 'bg-blue-600' : 'bg-white/10'}`}
                            >
                              {s.icon}
                            </motion.div>
                            <span className="text-sm text-white font-medium">{s.title}</span>
                          </div>
                          {i < steps.length - 1 && (
                            <div className={`absolute top-6 left-1/2 w-full h-0.5 
                              ${step > s.number ? 'bg-blue-600' : 'bg-white/10'}`}
                            ></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Form Container */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 md:p-8 w-full"
                  >
                    <AnimatePresence mode='wait'>
                      <motion.div
                        key={step}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.3 }}
                      >
                        {step === 1 && (
                          <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-white mb-6">Personal Information</h2>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">First Name</label>
                                <input
                                  type="text"
                                  name="first_name"
                                  value={formData.first_name}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Last Name</label>
                                <input
                                  type="text"
                                  name="last_name"
                                  value={formData.last_name}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Date of Birth</label>
                                <input
                                  type="date"
                                  name="date_of_birth"
                                  value={formData.date_of_birth}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Nationality</label>
                                <input
                                  type="text"
                                  name="nationality"
                                  value={formData.nationality}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Gender</label>
                                <select
                                  name="gender"
                                  value={formData.gender}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select Gender</option>
                                  <option value="male" className="bg-gray-800">Male</option>
                                  <option value="female" className="bg-gray-800">Female</option>
                                  <option value="other" className="bg-gray-800">Other</option>
                                </select>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Personal Contact</label>
                                <input
                                  type="tel"
                                  name="personal_contact"
                                  value={formData.personal_contact}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Your phone number"
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Email Address</label>
                                <input
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Your email address"
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                                <p className="mt-1 text-xs text-blue-200">This email will be used for payment processing</p>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Region</label>
                                <select
                                  name="region"
                                  value={formData.region}
                                  onChange={handleRegionChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select Region</option>
                                  {Object.keys(ghanaRegionsAndDistricts).map((region) => (
                                    <option key={region} value={region} className="bg-gray-800">
                                      {region}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">District</label>
                                <select
                                  name="district"
                                  value={formData.district}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                  disabled={!formData.region}
                                >
                                  <option value="" className="bg-gray-800">Select District</option>
                                  {formData.region && ghanaRegionsAndDistricts[formData.region].map((district) => (
                                    <option key={district} value={district} className="bg-gray-800">
                                      {district}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Town</label>
                                <input
                                  type="text"
                                  name="town"
                                  value={formData.town}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter your town"
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {step === 2 && (
                          <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-white mb-6">Player Details</h2>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Position</label>
                                <select
                                  name="position"
                                  value={formData.position}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select Position</option>
                                  <option value="Goalkeeper" className="bg-gray-800">Goalkeeper</option>
                                  <option value="Defender" className="bg-gray-800">Defender</option>
                                  <option value="Midfielder" className="bg-gray-800">Midfielder</option>
                                  <option value="Forward" className="bg-gray-800">Forward</option>
                                </select>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Preferred Foot</label>
                                <select
                                  name="preferred_foot"
                                  value={formData.preferred_foot}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select Preferred Foot</option>
                                  <option value="left" className="bg-gray-800">Left</option>
                                  <option value="right" className="bg-gray-800">Right</option>
                                  <option value="both" className="bg-gray-800">Both</option>
                                </select>
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-blue-100 mb-1">
                                  Height (ft)
                                </label>
                                <input
                                  type="text"
                                  name="height"
                                  value={formData.height}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="e.g. 5 feet 10 inches"
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                                <p className="mt-1 text-xs text-blue-200">Enter height in feet and inches (e.g. 5'10")</p>
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-blue-100 mb-1">
                                  Do you have a current club?
                                </label>
                                <select
                                  name="has_current_club"
                                  value={formData.has_current_club}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select an option</option>
                                  <option value="yes" className="bg-gray-800">Yes</option>
                                  <option value="no" className="bg-gray-800">No</option>
                                </select>
                              </div>
                              {formData.has_current_club === "yes" && (
                                <div>
                                  <label className="block text-sm font-medium text-blue-100 mb-1">
                                    Current Club Name
                                  </label>
                                  <input
                                    type="text"
                                    name="current_club"
                                    value={formData.current_club}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Enter your current club name"
                                    className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                  />
                                </div>
                              )}
                              <div>
                                <label className="block text-sm font-medium text-blue-100 mb-1">
                                  Do you have a Club Card?
                                </label>
                                <select
                                  name="has_club_card"
                                  value={formData.has_club_card}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select an option</option>
                                  <option value="yes" className="bg-gray-800">Yes</option>
                                  <option value="no" className="bg-gray-800">No</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}

                        {step === 3 && (
                          <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-white mb-6">Academic Information</h2>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div className="md:col-span-2">
                                <label className="block text-blue-100 mb-2 text-sm">Current School</label>
                                <input
                                  type="text"
                                  name="current_school"
                                  value={formData.current_school}
                                  onChange={handleInputChange}
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Form/Class/Level</label>
                                <input
                                  type="text"
                                  name="grade"
                                  value={formData.grade}
                                  onChange={handleInputChange}
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {step === 4 && (
                          <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-white mb-6">Guardian Information</h2>
                            <div className="grid md:grid-cols-2 gap-6">
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Guardian Name</label>
                                <input
                                  type="text"
                                  name="guardian_name"
                                  value={formData.guardian_name}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Relationship</label>
                                <select
                                  name="relationship"
                                  value={formData.relationship}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                >
                                  <option value="" className="bg-gray-800">Select Relationship</option>
                                  <option value="father" className="bg-gray-800">Father</option>
                                  <option value="mother" className="bg-gray-800">Mother</option>
                                  <option value="guardian" className="bg-gray-800">Guardian</option>
                                </select>
                              </div>
                              <div>
                                <label className="block text-blue-100 mb-2 text-sm">Phone</label>
                                <input
                                  type="tel"
                                  name="phone"
                                  value={formData.phone}
                                  onChange={handleInputChange}
                                  required
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                />
                              </div>
                              <div className="md:col-span-2">
                                <label className="block text-blue-100 mb-2 text-sm">Address</label>
                                <textarea
                                  name="address"
                                  value={formData.address}
                                  onChange={handleInputChange}
                                  required
                                  rows="2"
                                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:border-blue-400 focus:ring-blue-400"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Success Message */}
                        {submitSuccess && (
                          <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="bg-green-500/20 border border-green-500 text-green-300 p-4 rounded-lg mb-6"
                          >
                            <div className="flex items-center">
                              <FaCheck className="text-green-400 mr-2" />
                              <p>Registration successful! Redirecting you to the success page...</p>
                            </div>
                          </motion.div>
                        )}

                        {/* Error Message */}
                        {submitError && (
                          <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="bg-red-500/20 border border-red-500 text-red-300 p-4 rounded-lg mb-6"
                          >
                            <p>{submitError}</p>
                          </motion.div>
                        )}

                        {/* Payment Information */}
                        {step === steps.length && (
                          <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="bg-yellow-600/20 border border-yellow-500/30 rounded-lg p-4 mb-6"
                          >
                            <h3 className="text-lg font-bold text-white mb-2">Payment Information</h3>
                            <p className="text-yellow-200">
                              A registration fee of <span className="font-bold">100.00 Cedis</span> is required for the trial registration form and participation in the trial at our academy premises.
                            </p>
                          </motion.div>
                        )}

                        {/* Navigation Buttons */}
                        <div className="flex justify-between mt-8">
                          {step > 1 && (
                            <motion.button
                              whileHover={{ scale: 1.05 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={prevStep}
                              className="px-8 py-3 rounded-lg bg-white/10 text-white hover:bg-white/20 transition-colors duration-200"
                              disabled={isSubmitting || paymentProcessing}
                            >
                              Previous
                            </motion.button>
                          )}
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={step === steps.length ? handleSubmit : nextStep}
                            className={`px-8 py-3 rounded-lg ${
                              step === steps.length
                                ? 'bg-green-600 hover:bg-green-700'
                                : 'bg-blue-600 hover:bg-blue-700'
                            } text-white transition-colors duration-200 ml-auto`}
                            disabled={isSubmitting || paymentProcessing}
                          >
                            {isSubmitting ? 'Submitting...' : 
                             paymentProcessing ? 'Processing Payment...' : 
                             step === steps.length ? 'Submit Application' : 'Next'}
                          </motion.button>
                        </div>
                      </motion.div>
                    </AnimatePresence>
                  </motion.div>
                </div>
              </div>
            </section>
          </div>
        </section>

        <Footer />
      </div>

      {/* Loader Modal */}
      {showLoader && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <div className="bg-white rounded-lg p-8 shadow-xl z-10 max-w-md w-full mx-4 text-center">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mb-4"></div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Wait Please</h3>
              <p className="text-gray-600">Your registration is being processed. Please do not close this page.</p>
            </div>
          </div>
        </div>
      )}

      {/* Verification Modal */}
      {showVerificationModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <div className="bg-white rounded-lg p-8 shadow-xl z-10 max-w-md w-full mx-4 text-center">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mb-4"></div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Verifying Data</h3>
              <p className="text-gray-600 mb-4">Please wait while we verify your information...</p>
              
              {verificationError && (
                <div className="mb-4">
                  <p className="text-red-500 mb-4">{verificationError}</p>
                  <button
                    onClick={verifyRegistration}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Try Again
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register; 